import { jsx as i } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import T from "@mui/material/Tooltip";
import f from "styled-components";
const g = {
  popper: "tooltipPopper",
  tooltip: "tooltipTooltip",
  tooltipArrow: "tooltipTooltipArrow",
  arrow: "tooltipArrow"
}, y = /* @__PURE__ */ l(({ className: o, ...t }, r) => /* @__PURE__ */ i(T, {
  ref: r,
  classes: {
    ...g,
    popper: o
  },
  ...t
})), m = f(y).withConfig({
  displayName: "StyledTooltip"
})([
  "& .tooltipTooltip{background-color:",
  ";font-size:",
  ";font-weight:",
  ";color:",
  ";line-height:18px;padding:8px 12px;}& .tooltipTooltipArrow .tooltipArrow{color:",
  ";}"
], ({ theme: o }) => o.isLightTheme ? o.colors.grey800 : o.colors.darkBlue200, ({ theme: o }) => o.typography.body200.fontSize, ({ theme: o }) => o.typography.fontWeightRegular, ({ theme: o }) => o.colors.white, ({ theme: o }) => o.isLightTheme ? o.colors.grey800 : o.colors.darkBlue200), w = /* @__PURE__ */ l(({ arrow: o = !0, enterDelay: t = 300, enterNextDelay: r = 300, enterTouchDelay: p = 700, leaveDelay: e = 0, leaveTouchDelay: s = 1500, placement: a = "bottom", classes: u, title: c, ...d }, n) => /* @__PURE__ */ i(m, {
  arrow: o,
  enterDelay: t,
  enterNextDelay: r,
  enterTouchDelay: p,
  leaveDelay: e,
  leaveTouchDelay: s,
  placement: a,
  title: c ?? "",
  ref: n,
  ...d
}));
w.displayName = "Tooltip";
export {
  w as default
};
